import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { TableRow, TableCell } from '@mui/material';
import { confirmDialog } from '../Reusable/ConfirmDialog';
import ModalForUpdateProductCategory from './ModalForUpdateProductCategory';


const ProductCategoryRow = ({
  category,
  updateProductCategory,
  deleteProductCategory,
  dispatch,
  productCategoryReducer,
  clearValidationErrors,
}) => {
  const [show, setShow] = useState(false);

  const onDeleteClick = (id) => {
    const action = () => {
      dispatch(deleteProductCategory(id));
    };
    confirmDialog('obrišete kategoriju', action, ', obriši!');
  };

  const showModalUpdate = () => {
    setShow(true);
  };

  const handlePreviewClose = () => {
    setShow(false);
    clearValidationErrors();
  };

  const handleEdit = (category) => {
    dispatch(updateProductCategory(category, handlePreviewClose));
  };

  let row = (
    <>
      <TableRow>
        <TableCell>{category.productCategoryName}</TableCell>

        <TableCell className="text-center" id="centerRow">
          <Link to="#" onClick={() => showModalUpdate()}>
            <i className="fas fa-edit fa-2x i" />
          </Link>
        </TableCell>
        <TableCell
          className={`text-center ${category.id === 2 && 'disable-events'}`}
        >
          <Link to="#" id="deleteProductCategory" onClick={() => onDeleteClick(category.id)}>
            <i
              className={`fas fa-trash-alt fa-2x ${
                category.id === 2 && 'disable-color'
              }`}
            />
          </Link>
        </TableCell>
      </TableRow>
    </>
  );

  return (
    <>
      {row}

      {show && (
        <ModalForUpdateProductCategory
          show={show}
          category={category}
          updateProductCategory={handleEdit}
          handleClose={handlePreviewClose}
          productCategoryReducer={productCategoryReducer}
        />
      )}
    </>
  );
};

export default ProductCategoryRow;
